<script>
export default {

  props: {
    data: {
      type: Object,
      required: false
    }
  },

  data () {
    return {}
  },

  methods: {
    cancelAction (data) {
      this.$emit('cancel', (typeof data === 'undefined') ? data : null)
    },

    confirmAction (data) {
      this.$emit('confirm', (typeof data === 'undefined') ? data : null)
    }
  }
}
</script>
